var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconMailConfirmed = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 60.83 55.35"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": 1
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "mail--color copy"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#e6ae45",
  d: "M26.46 0L0 12.22l26.46 22.53 26.45-22.53L26.46 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M4.45 10.55h43.41v20.64H4.45z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f7cf80",
  d: "M26.46 27.53L0 12.22v33.71h52.91V12.22L26.46 27.53z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4cbac0",
  d: "M42.88 46.16a9 9 0 119 9 9 9 0 01-9-9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 3,
  d: "M55.82 42.44l-5.11 6.15-2.88-2.4"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M42.41 36.97h18.38v18.38H42.41z"
}))))));
export default SvgIconMailConfirmed;